// extracted by mini-css-extract-plugin
module.exports = {"btnBlock":"Button_btnBlock__15-qV","button":"Button_button__1rSXQ"};